import { css } from 'styled-components'

import { isVelthuis } from '@/utils/common.ts'

export const font = isVelthuis ? 'ProximaNova' : 'TitilliumWeb'

export const headerFont = isVelthuis ? 'MetaSerifPro' : 'TitilliumWeb'

export const textSizeM = css`
  font-size: 17px;
  line-height: 22px;
  letter-spacing: 0.14px;
`

export const textSizeS = css`
  font-size: 14px;
  line-height: 20px;
  letter-spacing: 0.14px;
`
